module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-11@2x__46d979854354a9821abe0b0e9f0ebcf7.png";